import * as React from 'react';

import { LabelsBox } from '../../components/LabelsBox';
import * as styles from './LabelsDesktopContainer.css';

type TLabelsDesktopContainerProps = {
  visited: boolean;
};

export const LabelsDesktopContainer: React.FC<TLabelsDesktopContainerProps> = ({ visited }) => {
  if (!visited) {
    return null;
  }

  return (
    <LabelsBox>
      <span className={styles['visited-label']}>Вы смотрели</span>
    </LabelsBox>
  );
};
